import { yodaCustomerConstants } from "../constants";

const customerReducer = (
  state = {
    loading: false,
    customers: [],
  },
  action,
) => {
  switch (action.type) {
    case yodaCustomerConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
        //customers: []
      };

    case yodaCustomerConstants.GETALL_SUCCESS:
      action.payload.customers.forEach((e) => {
        e.checksum =
          (e.id || "") +
          "|" +
          (e.name || "") +
          "|" +
          (e.code || "") +
          "|" +
          (e.email || "") +
          "|" +
          (e.phone || "") +
          "|" +
          (e.city || "") +
          "|" +
          (e.address || "") +
          "|" +
          (e.zipCode || "") +
          "|" +
          (e.status || "") +
          "|" +
          (e.currencyId || "") +
          "|" +
          (e.keyIndex || "") +
          "|" +
          (e.priceContractId || "") +
          "|" +
          (e.accountPeriodId || "") +
          "|" +
          e.paymentId;
      });
      return {
        ...state,
        customers: action.payload.customers,
        loading: false,
      };

    case yodaCustomerConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaCustomerConstants.GETONE_REQUEST:
      return {
        ...state,
        //loading: true,
        //customer: []
      };

    case yodaCustomerConstants.GETONE_SUCCESS:
      return {
        ...state,
        customer: action.payload.customer,
        //loading: false
      };

    case yodaCustomerConstants.GETONE_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        //loading: false
      };

    default:
      return state;
  }
};

export default customerReducer;
